// extracted by mini-css-extract-plugin
export default {"containerWrap":"integrationsInfo_containerWrap__5uW9c","router":"integrationsInfo_router__R+C9U","section":"integrationsInfo_section__d+UAW"};